import React from 'react';
import $ from 'jquery';
import Loading from 'app/loading';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import {FormControlLabel, FormLabel} from 'material-ui/Form';
import classNames from 'classnames';
import SimpleReactValidator from 'simple-react-validator'
import IconButton from '@material-ui/core/IconButton'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {NotificationManager} from 'react-notifications';
import {get, post} from 'engine/dataServices';
import logo from 'assets/Images/H-Logo.png';
import Validator from 'components/Validator';
import {MenuItem, Radio, RadioGroup, withStyles} from "material-ui";
import Select from "react-select";
import Typography from "material-ui/Typography";
import Chip from "material-ui/Chip";
import ArrowDropDownIcon from 'material-ui-icons/ArrowDropDown';
import CancelIcon from 'material-ui-icons/Cancel';
import ArrowDropUpIcon from 'material-ui-icons/ArrowDropUp';
import ClearIcon from 'material-ui-icons/Clear';
import SimpleDialog from 'components/customized/dialogs/simpleDialog/SimpleDialog';
import ContractHtml from './../../../../../../data/Contract.html';

const ITEM_HEIGHT = 48;

const bankTypes = [
    {id: 0, name: 'accountNumber', faName: 'شماره حساب'},
    {id: 1, name: 'cardNumber', faName: 'شماره کارت'},
    {id: 2, name: 'shabaNumber', faName: 'شماره شبا'},
];

const styles = theme => ({
    root: {
        flexGrow: 1,
        minHeight: 100,
        justifyItems: 'center',
        width: '90%',
    },
    chip: {
        margin: theme.spacing.unit / 4,
    },
    // We had to use a lot of global selectors in order to style react-select.
    // We are waiting on https://github.com/JedWatson/react-select/issues/1679
    // to provide a better implementation.
    // Also, we had to reset the default style injected by the library.
    '@global': {
        '.Select-control': {
            display: 'flex',
            alignItems: 'center',
            border: 0,
            height: 'auto',
            background: 'transparent',
            '&:hover': {
                boxShadow: 'none',
            },
        },
        '.Select-multi-value-wrapper': {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
        },
        '.Select--multi .Select-input': {
            margin: 0,
        },
        '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
            padding: 0,
        },
        '.Select-noresults': {
            padding: theme.spacing.unit * 2,
        },
        '.Select-input': {
            display: 'inline-flex !important',
            padding: 0,
            height: 'auto',
        },
        '.Select-input input': {
            background: 'transparent',
            border: 0,
            padding: 0,
            cursor: 'default',
            display: 'inline-block',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            margin: 0,
            outline: 0,
        },
        '.Select-placeholder, .Select--single .Select-value': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(16),
            padding: 0,
        },
        '.Select-placeholder': {
            opacity: 0.42,
            color: theme.palette.common.black,
        },
        '.Select-menu-outer': {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
            position: 'absolute',
            left: 0,
            top: `calc(100% + ${theme.spacing.unit}px)`,
            width: '100%',
            zIndex: 2,
            maxHeight: ITEM_HEIGHT * 4.5,
        },
        '.Select.is-focused:not(.is-open) > .Select-control': {
            boxShadow: 'none',
        },
        '.Select-menu': {
            maxHeight: ITEM_HEIGHT * 4.5,
            overflowY: 'auto',
        },
        '.Select-menu div': {
            boxSizing: 'content-box',
        },
        '.Select-arrow-zone, .Select-clear-zone': {
            color: theme.palette.action.active,
            cursor: 'pointer',
            height: 21,
            width: 21,
            zIndex: 1,
        },
        // Only for screen readers. We can't use display none.
        '.Select-aria-only': {
            position: 'absolute',
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            height: 1,
            width: 1,
            margin: -1,
        },
    },
});

const RuleModalBody = (firstName, lastName, producerName, phoneNumber, instagramId, address, bankName, accountNumber, bankType) => {

    const seriallized =
        ContractHtml
            .replace('##FullName##', `${firstName} ${lastName}`)
            .replace('##ProducerName##', producerName)
            .replace('##Address##', address)
            .replace('##InstagramId##', instagramId)
            .replace('##BankName##', bankName)
            .replace('##AccountNumber##', accountNumber)
            .replace('##BankType##', bankType)
            .replace('##PhoneNumber##', phoneNumber);
    const htmlDoc = {__html: seriallized};

    return (
        <div dangerouslySetInnerHTML={htmlDoc}></div>
    );
}

function SelectWrapped(props) {
    const {classes, ...other} = props;

    return (
        <Select
            optionComponent={SelectOption}
            noResultsText={<Typography>{'No results found'}</Typography>}
            arrowRenderer={arrowProps => {
                return arrowProps.isOpen ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>;
            }}
            clearRenderer={() => <ClearIcon/>}
            valueComponent={valueProps => {
                const {value, children, onRemove} = valueProps;

                const onDelete = event => {
                    event.preventDefault();
                    event.stopPropagation();
                    onRemove(value);
                };

                if (onRemove) {
                    return (
                        <Chip
                            tabIndex={-1}
                            label={children}
                            className={classes.chip}
                            deleteIcon={<CancelIcon onTouchEnd={onDelete}/>}
                            onDelete={onDelete}
                        />
                    );
                }

                return <div className="Select-value">{children}</div>;
            }}
            {...other}
        />
    );
}

class SelectOption extends React.Component {
    handleClick = event => {
        this.props.onSelect(this.props.option, event);
    };

    render() {
        const {children, isFocused, isSelected, onFocus} = this.props;

        return (
            <MenuItem
                onFocus={onFocus}
                selected={isFocused}
                onClick={this.handleClick}
                component="div"
                style={{
                    fontWeight: isSelected ? 500 : 400,
                }}
            >
                {children}
            </MenuItem>
        );
    }
}

class StepperRegister extends React.Component {

    constructor(props) {
        super(props);

        this.validator = Validator();

        this.state = {
            activeStep: 0,
            mobile: '',
            confirmationCode: '',
            firstName: '',
            lastName: '',
            password: '',
            confirmPassword: '',
            showPassword: false,
            producerName: '',
            loading: false,
            instagramId: '',
            bankTypeId: 'accountNumber',
            bankAccountOwnerName: '',
            bankName: '',
            bankNumber: '',
            provinces: [],
            cities: [],
            selectedProvince: 3,
            selectedCity: 151,
            address: '',
            rulesApproved: false,
            showModal: false
        };

        this.handleLoading(false);

        this.loadProvinces();
        this.loadCities(3);
    }

    componentWillMount() {
    }


    componentDidMount() {
        if ($('.warm-canvas').length) {
            $('.warm-canvas').glassyWorms({
                colors: ['#fff', '#c2c2c2'],
                useStyles: true,
                numParticles: 450,
                tailLength: 20,
                maxForce: 8,
                friction: 0.75,
                gravity: 9.81,
                interval: 3
                // colors: ['#000'],
                // element: $('<canvas class="worms"></canvas>')[0]
            });
        }
    }

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    handleReset = () => {
        this.setState({
            activeStep: 0,
            mobile: '',
            confirmationCode: ''
        });
    };

    handleClickShowPassword = () => {
        this.setState(state => ({showPassword: !state.showPassword}));
    };

    handleChange = prop => event => {
        this.setState({[prop]: event.target.value});
    };

    handleRadioGroupChange = (event, value) => {
        this.setState({bankTypeId: value});
    };

    handleSelectChange = prop => value => {
        if (prop == 'selectedProvince')
            this.loadCities(value);

        this.setState({
            [prop]: value,
        });
    };


    async loadProvinces() {
        let response = await get(`Address/GetCitiesByParent?parentId=1`);
        if (response.status === 200) {
            let _provinces = await response.json();
            let serialized = _provinces.map(item => ({label: item.Name, value: item.Id}));
            this.setState({provinces: serialized});
        }
    }

    async loadCities(selectedProvince) {
        let response = await get(`Address/GetCitiesByParent?parentId=${selectedProvince}`);
        if (response.status === 200) {
            let _cities = await response.json();
            let serialized = _cities.map(item => ({label: item.Name, value: item.Id}));
            this.setState({cities: serialized});
        }
    }


    getMobile() {
        return <div>
            <TextField
                id="mobile"
                label="تلفن همراه"
                fullWidth
                onChange={(event) => this.setState({mobile: event.target.value})}
                defaultValue={this.state.mobile}
                margin="normal"
                className="mt-1"
            />
            {this.validator.message('تلفن همراه', this.state.mobile, 'required|mobile')}
        </div>
    }

    getConfirmationCode() {
        return <div>
            <span>کد فعالسازی به شماره {this.state.mobile} پیامک خواهد شد.</span>
            <TextField
                type="text"
                id="confirmationCode"
                label="کد فعالسازی"
                fullWidth
                defaultValue={this.state.confirmationCode}
                onChange={(event) => this.setState({confirmationCode: event.target.value})}
                margin="normal"
                className="mt-1"
            />
            {this.validator.message('کد فعالسازی', this.state.confirmationCode, 'required|integer|size:6')}
            <div style={{marginTop: 15}}>
                <a href="javascript:void(0)" onClick={() => this.setState({activeStep: 0})}>تغییر شماره تلفن همراه</a>
            </div>
        </div>
    }

    getUserDataRegisterForm() {
        const {instagramId} = this.state;

        return <div>
            <h2 style={{fontWeight: 'bold', textAlign: 'center', margin: 0}}>اطلاعات کاربری</h2>
            <div className="row">
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <TextField
                            type="text"
                            id="firstName"
                            label="نام"
                            fullWidth
                            defaultValue={this.state.firstName}
                            onChange={(event) => this.setState({firstName: event.target.value})}
                            margin="normal"
                        />
                        {this.validator.message('نام', this.state.firstName, 'required|persianChars|min:2')}
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <TextField
                            type="text"
                            id="lastName"
                            label="نام خانوادگی"
                            fullWidth
                            defaultValue={this.state.lastName}
                            onChange={(event) => this.setState({lastName: event.target.value})}
                            margin="normal"
                        />
                        {this.validator.message('نام خانوادگی', this.state.lastName, 'required|persianChars|min:2')}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                        <TextField
                            type="text"
                            id="producerName"
                            label="نام تولیدی"
                            fullWidth
                            defaultValue={this.state.producerName}
                            onChange={(event) => this.setState({producerName: event.target.value})}
                            style={{margin: 0}}
                            margin="normal"
                        />
                        {this.validator.message('عنوان تولیدی', this.state.producerName, 'required')}
                    </div>
                </div>
            </div>
            <FormControl fullWidth className="mb-2 mt-2">
                <InputLabel htmlFor="password">کلمه عبور</InputLabel>
                <Input
                    id="password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    value={this.state.password}
                    onChange={this.handleChange('password')}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="تغییر وضعیت نمایش کلمه عبور"
                                onClick={this.handleClickShowPassword}
                                onMouseDown={this.handleMouseDownPassword}
                            >
                                {this.state.showPassword ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
            {this.validator.message('کلمه عبور', this.state.password, 'required')}
            <TextField
                type="password"
                id="confirmPassword"
                label="تایید کلمه عبور"
                fullWidth
                defaultValue={this.state.confirmPassword}
                onChange={(event) => this.setState({confirmPassword: event.target.value})}
                margin="normal"
                className="mt-3"
            />
            {this.validator.message('تایید کلمه عبور', this.state.confirmPassword, `confirmPassword:${this.state.password}`)}
            <TextField
                type="text"
                id="instagramId"
                label="آدرس اینستاگرام"
                fullWidth
                defaultValue={instagramId}
                onChange={(event) => this.setState({instagramId: event.target.value})}
                margin="normal"
                className="mt-3"
            />
        </div>
    }

    getBankDataRegisterForm() {
        const {bankTypeId, bankAccountOwnerName, bankName, bankNumber} = this.state;
        let bankNumberTypeTxt = bankTypes.find(x => x.name == bankTypeId).faName;

        return <div>
            <h2 style={{fontWeight: 'bold', textAlign: 'center'}}>اطلاعات حساب بانکی</h2>
            <span>یکی از اطلاعات بانکی ذیل را انتخاب نموده و اطلاعات خواسته شده را تکمیل بفرمایید.</span>
            <br/>
            <FormControl component="fieldset">
                <RadioGroup
                    aria-label="bankNumberType"
                    name="bankNumberType"
                    value={bankTypeId}
                    onChange={this.handleRadioGroupChange}
                    row={true}
                >
                    {bankTypes.map(item => (
                        <FormControlLabel value={item.name} control={<Radio/>} label={item.faName}/>))}
                </RadioGroup>
            </FormControl>
            <TextField
                type="text"
                id="bankAccountOwnerName"
                label="نام و نام خانوادگی دارنده حساب"
                fullWidth
                defaultValue={bankAccountOwnerName}
                onChange={(event) => this.setState({bankAccountOwnerName: event.target.value})}
                margin="normal"
                className="mt-1"
            />
            {this.validator.message('نام و نام خانوادگی دارنده حساب', this.state.bankAccountOwnerName, 'required')}
            <TextField
                type="text"
                id="bankNumber"
                label={bankNumberTypeTxt}
                fullWidth
                defaultValue={bankNumber}
                onChange={(event) => this.setState({bankNumber: event.target.value})}
                margin="normal"
                className="mt-1"
            />
            {this.validator.message('اطلاعات حساب', this.state.bankNumber, 'required')}
            <TextField
                type="text"
                id="bankName"
                label="نام بانک"
                fullWidth
                defaultValue={bankName}
                onChange={(event) => this.setState({bankName: event.target.value})}
                margin="normal"
                className="mt-1"
            />
            {this.validator.message('نام بانک', this.state.bankName, 'required')}
        </div>
    }

    getUserAddressRegisterForm() {
        const {classes} = this.props;
        const {single, provinces, selectedProvince, selectedCity, cities, address, bankTypeId} = this.state;
        const {firstName, lastName, producerName, mobile, instagramId, bankName, bankNumber} = this.state;
        const {showModal} = this.state;

        const bankType = bankTypes.find(x => x.name == bankTypeId).faName;

        return (<div>
                <h2 style={{fontWeight: 'bold', textAlign: 'center'}}>اطلاعات آدرس تولیدی</h2>
                <div className='row mt-4'>
                    <div className='col-6'>
                        <label>استان</label>
                        <Input
                            fullWidth
                            inputComponent={SelectWrapped}
                            inputProps={{
                                classes,
                                value: selectedProvince,
                                onChange: this.handleSelectChange('selectedProvince'),
                                placeholder: 'استان',
                                instanceId: 'react-select-single',
                                id: 'react-select-single',
                                name: 'react-select-single',
                                simpleValue: true,
                                options: provinces,
                            }}
                        />
                        {this.validator.message('استان', this.state.selectedProvince, 'required')}
                    </div>
                    <div className='col-6'>
                        <label>شهر</label>
                        <Input
                            fullWidth
                            inputComponent={SelectWrapped}
                            inputProps={{
                                classes,
                                value: selectedCity,
                                onChange: this.handleSelectChange('selectedCity'),
                                placeholder: 'شهر',
                                instanceId: 'react-select-single',
                                id: 'react-select-single',
                                name: 'react-select-single',
                                simpleValue: true,
                                options: cities,
                            }}
                        />
                        {this.validator.message('شهر', this.state.selectedCity, 'required')}
                    </div>
                </div>
                <TextField
                    id="multiline-flexible"
                    label="آدرس"
                    multiline
                    rowsMax="4"
                    rows="3"
                    value={address}
                    onChange={this.handleChange('address')}
                    margin="normal"
                    fullWidth
                />
                {this.validator.message('آدرس', this.state.address, 'required')}
                <div style={{marginTop: 40}}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                value="gilad"
                                onChange={(checked) => this.setState({rulesApproved: checked})}
                            />
                        }
                        label="قرار داد مطالعه شده و مورد تایید است."
                    />
                    <div style={{textAlign: 'center'}}>
                        <Button variant="raised" className="bg-primary text-white"
                                onClick={() => this.setState({showModal: true})}>
                            مطالعه قرار داد
                        </Button>
                    </div>
                </div>
                <SimpleDialog title='قرار داد و قوانین'
                              Body={RuleModalBody.bind(this, firstName, lastName, producerName, mobile, instagramId, address, bankName, bankNumber, bankType)}
                              open={showModal}
                              onClose={this.handleModalRequestClose.bind(this)}
                />
            </div>
        );
    }

    handleModalRequestClose = value => {
        this.setState({showModal: false});
    };

    nextStep = () => {
        const {activeStep} = this.state;
        this.setState({
            activeStep: activeStep + 1,
        });
    }

    handleNext = async () => {
        const {activeStep} = this.state;
        if ((this.validator.fieldValid('تلفن همراه') && activeStep === 0) ||
            (this.validator.fieldValid('کد فعالسازی') && activeStep === 1) ||
            (this.validator.fieldValid('نام') && this.validator.fieldValid('نام خانوادگی') && this.validator.fieldValid('عنوان تولیدی') && this.validator.fieldValid('کلمه عبور') && this.validator.fieldValid('تایید کلمه عبور') && activeStep === 2) ||
            (this.validator.fieldValid('نام و نام خانوادگی دارنده حساب') && this.validator.fieldValid('اطلاعات حساب') && this.validator.fieldValid('نام بانک') && activeStep === 3) ||
            (this.validator.fieldValid('استان') && this.validator.fieldValid('شهر') && this.validator.fieldValid('آدرس') && activeStep === 4)) {
            this.handleLoading(true);
            switch (activeStep) {
                case 0: //getMobile
                    var res = await post('Producer/SignUp', {Mobile: this.state.mobile});
                    if (res.status == 200) {
                        this.nextStep();
                    }
                    break;
                case 1: //getConfirmationCode
                    var res = await post('Producer/VerifyCode', {
                        Mobile: this.state.mobile,
                        Code: this.state.confirmationCode
                    });
                    if (res.status == 200) {
                        this.setState({confirmationCode: ''})
                        this.nextStep();
                    }
                    break;
                case 2: //getUserDataRegisterForm
                    this.nextStep();
                    break;
                case 3: //getBankDataRegisterForm
                    this.nextStep();
                    break;
                case 4: //getUserAddressRegisterForm
                    const {rulesApproved} = this.state;
                    if (!rulesApproved) {
                        NotificationManager.error('مطالعه و تایید متن قرارداد و قوانین تولیتون الزامیست.', 'خطا');
                        break;
                    }

                    const {bankAccountOwnerName, bankTypeId, bankName, bankNumber} = this.state;
                    const {selectedCity, address} = this.state;
                    const _bankTypeId = bankTypes.find(x => x.name == bankTypeId).id;
                    const res = await post('Producer/Register', {
                        Mobile: this.state.mobile,
                        Code: this.state.confirmationCode,
                        FirstName: this.state.firstName,
                        LastName: this.state.lastName,
                        Password: this.state.password,
                        Producer: {
                            Name: this.state.producerName,
                            InstagramId: this.state.instagramId,
                            BankAccount: {
                                OwnerName: bankAccountOwnerName,
                                Type: _bankTypeId,
                                Value: bankNumber,
                                BankName: bankName
                            }
                        },
                        Address: {
                            CityId: selectedCity,
                            Address: address
                        }
                    });
                    if (res.status == 200) {
                        this.nextStep();
                    }
                    break;
            }
            this.handleLoading(false);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };


    handleBack = () => {
        const {activeStep} = this.state;
        this.setState({
            activeStep: activeStep - 1,
        });
    };

    getStepContent(stepIndex) {
        //return this.getUserAddressRegisterForm();
        switch (stepIndex) {
            case 0:
                return this.getMobile();
            case 1:
                return this.getConfirmationCode();
            case 2:
                return this.getUserDataRegisterForm();
            case 3:
                return this.getBankDataRegisterForm();
            case 4:
                return this.getUserAddressRegisterForm();
            default:
                return 'Login Successfully';
        }
    }

    getButtonName(step) {
        switch (step) {
            case 0:
                return 'ثبت';
            case 1:
                return 'تایید کد';
            case 2:
                return 'تکمیل 1 از 3';
            case 3:
                return 'تکمیل 2 از 3';
            case 4:
                return 'تکمیل ثبت نام';
        }
    }

    render() {
        const steps = 5;
        const {activeStep} = this.state;

        return (
            <div
                className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3 warm-canvas">
                {this.state.loading && <Loading/>}
                <div className="login-content">
                    <div className="login-header mb-4">
                        <a className="app-logo" href="#/" title="Apall">
                            <img src={logo} alt="Apall" title="Apall"/>
                        </a>
                    </div>

                    <div className="login-form">
                        {this.state.activeStep === steps ?
                            <div>
                                <div className="my-2">
                                    ثبت نام شما تکمیل شد. منتظر تایید و اطلاع مدیر سیستم باشید.
                                </div>
                                <Button onClick={this.handleReset}>خانه</Button>
                            </div>
                            :
                            <form>
                                <fieldset>

                                    {this.getStepContent(activeStep)}


                                    <div
                                        className={`mt-4 mb-2 ${activeStep == 0 ? 'd-flex justify-content-between align-items-center' : 'text-left'}`}>
                                        {activeStep === 0 &&
                                        <div>
                                            <a className="text-primary" href="#/app/accounthandler/login"
                                               title="Login">حساب کاربری دارید؟ وارد شوید</a>
                                        </div>
                                        }
                                        <Button variant="raised"
                                                className="jr-btn btn-yellow-background font-weight-bold"
                                                onClick={this.handleNext}>
                                            {this.getButtonName(activeStep)}
                                        </Button>
                                    </div>
                                </fieldset>
                            </form>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(StepperRegister);



// WEBPACK FOOTER //
// ./app/routes/appModule/routes/signUp/StepperRegister.js